<template>
  <v-alert
    v-if="active"
    class="mb-0"
    border="bottom"
    type="error"
    colored-border
    elevation="4"
  >
    {{ message }}
  </v-alert>
</template>

<script>
import { eventBus } from '@/main'
export default {
  data () {
    return {
      array: [],
      message: null,
      active: false,
      timeout: null
    }
  },
  created () {
    eventBus.$on('APP_ALERT_ERROR', (data) => {
      if (this.timeout) clearTimeout(this.timeout)
      if (this.active) this.active = false
      if (!data) return
      this.message = data
      this.active = true
      this.timeout = setTimeout(() => { this.active = false }, 5000)
    })
  }
}
</script>
